import SupportModalContainer from './containers/SupportModalContainer'

export default SupportModalContainer
